import api from "@/lib/api";

function hHeader() {
  const c = typeof document !== "undefined" ? document.cookie
    .split(";").map(x => x.trim()).find(x => x.startsWith("active_hotel_id=")) : null;
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return v ? { "X-Hocp-Hotel": v } : {};
}
const H = () => ({ headers: hHeader() });

export const opsAPI = {
  missionControl: () => api.get("/ops/v1/mission-control", H()).then(r => r.data),
  briefing:       () => api.get("/ops/v1/briefing", H()).then(r => r.data),
  healthScore:    () => api.get("/ops/v1/health-score", H()).then(r => r.data),
  kpis:           () => api.get("/ops/v1/kpis", H()).then(r => r.data),
  insights:       (params={}) => api.get("/ops/v1/insights", { ...H(), params }).then(r => r.data),
  recommendations:() => api.get("/ops/v1/recommendations", H()).then(r => r.data),
  risks:          () => api.get("/ops/v1/risks", H()).then(r => r.data),
  timeline:       (params={}) => api.get("/ops/v1/timeline", { ...H(), params }).then(r => r.data),
  evaluate:       () => api.post("/ops/v1/evaluate", {}, H()).then(r => r.data),
  insightAction:  (id, action, metadata) => api.post(`/ops/v1/insights/${id}/action`, { action, metadata }, H()).then(r => r.data),
  aiQuestions:    () => api.get("/ops/v1/ai-answer/questions", H()).then(r => r.data),
  aiAnswer:       (id) => api.get(`/ops/v1/ai-answer/${id}`, H()).then(r => r.data),
  predictions:    () => api.get("/ops/v1/predictions", H()).then(r => r.data),
  act:            (id) => api.post(`/ops/v1/insights/${id}/act`, {}, H()).then(r => r.data),
  trends:         (hours = 24) => api.get(`/ops/v1/trends?hours=${hours}`, H()).then(r => r.data),
  streamUrl:      () => {
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    const c = typeof document !== "undefined" ? document.cookie
      .split(";").map(x => x.trim()).find(x => x.startsWith("active_hotel_id=")) : null;
    const hid = c ? decodeURIComponent(c.split("=")[1]) : null;
    return `${base}/api/ops/v1/stream${hid ? `?hotel=${encodeURIComponent(hid)}` : ""}`;
  },
};
